import React from 'react';

import { PartnerPortalDashboard } from './PartnerPortalDashboard';

import { PARTNER_PORTAL_HEADER, PARTNER_PORTAL, ADMINS } from '../../constants/Pages/PartnerWithUs';

import './PartnerPortalInfo.css';

export const PartnerPortalInfo = ({
  PartnerPortalInfo: { Admins, PartnerHub_Access, PartnerHub_Dashboard },
}) => {
  return (
    <div className="partner-portal-info-container">
      <div>
        <div className="partner-portal-info-header">{PARTNER_PORTAL_HEADER}</div>

        <div className="partner-portal-info-row-wrapper">
          <div className="partner-portal-info-row-title">{PARTNER_PORTAL}</div>
          <div className="partner-portal-info-row-description">{PartnerHub_Access}</div>
        </div>

        <div className="partner-portal-info-row-wrapper">
          <div className="partner-portal-info-row-title">{ADMINS}</div>

          <div className="partner-portal-info-row-description">
            {Admins.map((adminAccess) => (
              <div>{adminAccess}</div>
            ))}
          </div>
        </div>

        <PartnerPortalDashboard PartnerHub_Dashboard={PartnerHub_Dashboard} />
      </div>
    </div>
  );
};
